import { api } from '../api/client';

import { API_USER_PREFERENCES_URL } from '../utils';

export async function getPreferences() {
	const { data } = await api.get(API_USER_PREFERENCES_URL);
	return data || {};
}

// Partial update: only the supplied keys change. A null value resets that
// key to its default. Returns the full updated preference map.
export async function patchPreferences(partial) {
	const { data } = await api.patch(API_USER_PREFERENCES_URL, partial);
	return data || {};
}
